// extracted by mini-css-extract-plugin
export default {"mealTabsList":"MealPlanView_mealTabsList__OIZbF","mealTab":"MealPlanView_mealTab__JOUyl"};